/*
Function to determine the deviceType (DESKTOP, PHONE, etc.)
by reading the context object on the header.
header returns this by reading the Akamai header X-${brand}-Device

@return String representation of the device type
"DESKTOP", "PHONE", "TABLET"
*/

import { DeviceType } from '../util/Constants';

export default function getDeviceType() {
  let deviceType = DeviceType.DESKTOP;

  try {
    const header = document.querySelector('header');
    let configObj;
    if (typeof header.dataset !== 'undefined' && typeof header.dataset.context !== 'undefined') {
      configObj = JSON.parse(header.dataset.context);
      if (configObj && configObj.deviceType) {
        ({ deviceType } = configObj);
      }
    } else {
      configObj = document.querySelector("script[data-bootstrap='configs']");
      deviceType = configObj ? JSON.parse(configObj.innerHTML).headerFooterContext.deviceType : deviceType;
    }
  } catch (e) {
    console.error(`Error in fetching deviceType - setting deviceType to ${DeviceType.DESKTOP}: `);
  }

  return deviceType;
}
